module.exports = __webpack_public_path__ + "img/p-12.34a936a7.webp";